(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.bubblu-header__nav').forEach(function (nav) {
      var toggle = nav.querySelector('.bubblu-header__menu-toggle');
      var panel = nav.querySelector('.bubblu-header__menu-panel');
      if (!toggle || !panel) return;

      var clickedToggle = toggle.contains(event.target);
      var clickedInsidePanel = panel.contains(event.target);

      if (clickedToggle) {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        return;
      }

      if (!clickedInsidePanel) {
        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bubblu-header__nav').forEach(function (nav) {
      var toggle = nav.querySelector('.bubblu-header__menu-toggle');
      var panel = nav.querySelector('.bubblu-header__menu-panel');
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
